import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M97.7099 72.21C98.1399 64.47 91.3199 60.9799 88.4599 48.6499C86.4399 39.9299 88.49 30.63 77.67 18.48C77.67 18.48 68.0899 0.200023 48.6099 1.64002L48.2799 1.75001C27.0299 -0.00999165 18.45 19.14 18.45 19.14C7.67996 31.18 9.31995 45.68 8.87995 55.36C8.70995 59.13 7.94996 62.67 6.22996 64.5C1.16996 69.89 1.05996 74.96 3.03996 77.71C6.01996 81.85 10.9699 81.23 10.9699 81.23C14.8199 85.08 27.1 85.67 29.38 73.01C30.73 65.48 27.2599 59.3599 24.9399 54.7899C23.1999 51.3499 22.57 47.83 22.57 47.83C25.03 47.83 26.94 45.91 27.82 44.83C29.42 44.59 37.4599 42.8 35.9899 30.64C35.9899 30.64 43.55 44.27 58.07 40.71C58.07 40.71 61.48 45.01 70.07 44.12C70.07 44.12 72.4399 47.82 75.85 47.82C75.85 47.82 75.22 51.3399 73.48 54.7799C71.16 59.3599 67.95 65.43 69.04 73C70.66 84.3 83.9799 84.19 87.8399 80.34C87.7999 80.36 97.2699 80.14 97.7099 72.21Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M53.5599 1.85999C53.5599 1.85999 63.7999 2.18995 66.5499 18.7C68.6799 31.46 65.8699 47.1199 76.2399 47.6499"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M65.23 12.5399C65.23 12.5399 85.74 23.6899 79.32 51.3999C77.23 60.4299 74.15 68.5699 76.02 73.4199C78.28 79.2699 87.67 78.4 90.33 71.99C90.33 71.99 90.91 81.27 83.5 82.34"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M81.8599 23.88C81.8599 23.88 87.7499 32.1999 85.8199 45.6799C83.8899 59.1599 80.6599 63.7 80.8699 69.46C81.0899 75.74 86.9299 75.96 89.1299 73.97"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M48.59 2.01001C48.59 2.01001 54.19 2.53993 55.66 12.4299C57.73 26.3599 52.06 42.47 64.8 44.25"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M55.97 41.3199C55.97 41.3199 47.73 40.84 48.41 27.84C49.04 15.8 52.44 4.6799 48.58 2.0199"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M29.395 37.1092C29.2437 38.1418 29.0702 39.1758 28.8176 40.1834C29.0091 39.1496 29.1248 38.1022 29.2275 37.0799H29.2275L29.228 37.0743C29.3642 35.5461 29.4572 34.0197 29.5502 32.4941C29.7406 29.3685 29.9308 26.2463 30.492 23.1192C31.3421 18.4935 32.9797 13.9951 35.6696 10.1367C36.2366 9.3297 36.8535 8.55532 37.5178 7.8265C36.8985 8.59603 36.3269 9.40191 35.7984 10.2313L35.7983 10.2313L35.7958 10.2354C34.5662 12.2067 33.5613 14.3083 32.7701 16.499C31.9703 18.686 31.3728 20.9239 30.9777 23.2124C30.5586 25.5008 30.3246 27.8196 30.1145 30.1386C30.083 30.4872 30.0519 30.8357 30.0209 31.1842C29.8451 33.16 29.6694 35.1334 29.395 37.1092Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M34.85 11.6599C34.85 11.6599 31.88 11.5499 26.7 16.2799C18.64 23.6599 15.25 39.1799 20.52 54.0599C24.56 65.4799 25.22 68.75 23.14 73.51C20.53 79.47 10.98 78.6199 8.31 72.2099C8.31 72.2099 8.16999 82.2599 15.58 83.3299"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.14 23.88C15.14 23.88 9.19994 33.1299 11.6199 45.8999C14.1599 59.2799 19.8799 62.4099 19.2199 69.6799C18.6699 75.7699 13.2199 76.55 11.2899 75.51"
        stroke={outline}
        strokeMiterlimit="10"
      />
    </g>
  )
}
